import { SettingsField } from './settings-field.model';

export class SettingsSubSection {
  constructor(public label: string, public settings: Array<SettingsField>) {}
}
